import JsDownload from 'js-file-download';
import { notification } from 'antd';
import { notifyMassiveError } from './serviceError';

export const saveBlob = (blob: Blob, filename: string) => {
  JsDownload(blob, filename);
};

const readBlobAsText = (blob: Blob): Promise<string> =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => resolve('');
    reader.readAsText(blob);
  });

export const downloadOrNotify = async (
  request: () => Promise<Blob>,
  filename: string,
): Promise<boolean> => {
  try {
    const blob = await request();
    if (blob.type.includes('application/json')) {
      const body = await readBlobAsText(blob);
      const parsed = JSON.parse(body || '{}');
      notification.info({
        message: 'Atención',
        description: parsed.message ?? 'El archivo todavía no está disponible.',
      });
      return false;
    }
    saveBlob(blob, filename);
    return true;
  } catch (error) {
    notifyMassiveError(error, 'No se pudo descargar el archivo');
    return false;
  }
};
